import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css";
import { useEffect } from "react";
import LazyLoad from "react-lazyload";

export default function Hero() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="bg-black">
      <div className=" absolute min-h-[88vh] md:h-[90vh] bg-opacity-50  bg-black  top-0 right-0 left-0   "></div>
      <Swiper
        modules={[Navigation, EffectFade, Autoplay]}
        navigation
        speed={2000}
        spaceBetween={800}
        slidesPerView={1}
        loop
        autoplay={{
          delay: 7000,
          disableOnInteraction: false,
        }}
      >
        <SwiperSlide>
          <div
            className=" h-[90vh] bg-[25%] md:bg-center bg-no-repeat bg-cover relative "
            style={{ backgroundImage: `url('/img/dash1.jpg')` }}
          ></div>
        </SwiperSlide>

        <SwiperSlide>
          <div
            className=" h-[90vh] bg-[25%] md:bg-center bg-no-repeat bg-cover relative "
            style={{ backgroundImage: `url('/img/dash2.jpg')` }}
          ></div>
        </SwiperSlide>

        <SwiperSlide>
          <div
            className=" h-[90vh] bg-[25%] md:bg-center bg-no-repeat bg-cover relative "
            style={{ backgroundImage: `url('/img/dash3.jpg')` }}
          ></div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
